import { AuthService } from '../../auth/auth.service';
import { SmwService } from '../../smw/smw.service';

import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  inject,
  Injector,
  input,
  OnInit,
  signal,
  TemplateRef,
  untracked,
  viewChild,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Router } from '@angular/router';

import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { ALARM_ORDER } from './constants';
import { TippyDirective } from '@ngneat/helipopper';
import { isNil } from 'src/utils/utils';

export const MODULES = [CommonModule, MatCardModule, TranslateModule];
export const COMPONENTS = [FaIconComponent];
export const DIRECTIVES = [TippyDirective];

@Component({
  selector: 'app-dashboard-gma-alarm',
  templateUrl: './dashboard-gma-alarm.component.html',
  styleUrls: [
    './dashboard-gma-alarm.component.scss',
    '../dashboard.component.scss',
  ],
  imports: [...MODULES, ...COMPONENTS, ...DIRECTIVES],
})
export class DashboardGmaAlarmComponent implements OnInit {
  private injector = inject(Injector);
  private auth = inject(AuthService);
  public smwService = inject(SmwService);
  public translate = inject(TranslateService);
  private router = inject(Router);

  refresh = input<number>();
  topCardsGmaAlarmTemplate = viewChild<TemplateRef<any>>('topCardsGmaAlarm');

  previousRefresh = signal(null);
  gmaAlarms = signal([]);
  stationNames = {};
  smwData;
  worsestAlarm = signal(0);
  alarmOrder = ALARM_ORDER;
  isLoading = true;

  constructor() {
    this.refreshSmwData();
  }

  ngOnInit(): void {
    this.getLatestSmwData();
  }

  getLatestSmwData(): void {
    const gmaAlarmStations = this.findStationWithGmaAlarm();
    if (gmaAlarmStations.length > 0) {
      this.smwService.getLatestDataForStations(gmaAlarmStations).subscribe(
        data => {
          this.extractAlarms(gmaAlarmStations, data);
          this.isLoading = false;
        },
        error => console.log('Error DashboardGMAAlarm getLatestSmwData', error)
      );
    }
  }

  extractAlarms(stations: Array<string>, smwData: any): void {
    this.gmaAlarms.set([]);
    for (const stationId of stations) {
      if (smwData.hasOwnProperty(stationId)) {
        const dataset = smwData[stationId];
        if (dataset.hasOwnProperty('gmaAlarm')) {
          const alarm = dataset['gmaAlarm'];
          if (alarm) {
            this.gmaAlarms.update(gmaAlarms => {
              gmaAlarms.push({
                id: stationId,
                name: this.stationNames[stationId],
                value: dataset['gmaAlarm'],
              });
              return [...gmaAlarms];
            });
            this.worsestAlarm.update(worsestAlarm => {
              return Math.max(worsestAlarm, this.alarmOrder.indexOf(alarm));
            });
          }
        }
      }
    }
  }

  findStationWithGmaAlarm(): Array<string> {
    const gmaAlarmStations = [];
    const customerDocument = this.auth.getCustomerDocument();
    for (const egwGmaProduct of customerDocument.egwGmaProducts) {
      if (this.auth.isProductActive('egwGmaProducts', egwGmaProduct.id)) {
        for (const station of egwGmaProduct.stations) {
          gmaAlarmStations.push(station.stationId);
          this.stationNames[station.stationId] = station.overwriteStationName;
        }
      }
    }
    return gmaAlarmStations;
  }

  onNavigateToSmwPage(): void {
    this.router.navigate(['smw']);
  }

  private refreshSmwData() {
    effect(
      () => {
        const refresh = this.refresh();
        untracked(() => {
          const previousRefresh = this.previousRefresh();
          if (!isNil(previousRefresh) && refresh > previousRefresh) {
            if (refresh > 1) {
              this.isLoading = true;
              this.getLatestSmwData();
            }
          }
          this.previousRefresh.set(refresh);
        });
      },
      { injector: this.injector }
    );
  }
}
